import { useGetApiKeyMetadata } from '@api/bff/apiKeys/queries/useGetApiKeyMetadata';
import { useGenerateApiKey } from '@api/bff/apiKeys/mutations/useGenerateApiKey';
import { useRevokeApiKey } from '@api/bff/apiKeys/mutations/useRevokeApiKey';
import type { GeneratedApiKeyViewModel } from '@api/bff/apiKeys/types';

export const useApiKey = () => {
  const { data: metadata, isLoading } = useGetApiKeyMetadata();
  const generateMutation = useGenerateApiKey();
  const revokeMutation = useRevokeApiKey();

  const generate = async (): Promise<GeneratedApiKeyViewModel | null> => {
    try {
      return await generateMutation.mutateAsync();
    } catch {
      return null;
    }
  };

  const revoke = async (): Promise<void> => {
    await revokeMutation.mutateAsync();
  };

  return {
    metadata: metadata ?? null,
    isLoading,
    generate,
    revoke,
    isGenerating: generateMutation.isPending,
    isRevoking: revokeMutation.isPending
  };
};
